import Cookies from 'js-cookie';
import { PromoDetails } from './types';

const setPromoDetailsCookie = (promoDetails: PromoDetails) => {
  Cookies.set('promoDetails', promoDetails);
  return;
};

export default setPromoDetailsCookie;
